export default "__VITE_ASSET__CMRsfr2U__"